import { SOFTWARE } from '../constant/actionTypes';

const getSoftwareSubmoduleData = (state, action) => {
  switch (action.type) {
    case SOFTWARE.SUBMODULE_DATA.INITIATE:
      return { isFetching: true };
    case SOFTWARE.SUBMODULE_DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case SOFTWARE.SUBMODULE_DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getSoftwareSubmoduleData;
